var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendToFriendImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1094_3781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.7777 9.33322C0.348133 9.33322 0 8.98508 0 8.55552V7.62218C0 6.23782 0 5.47528 0.339033 4.80982C0.639333 4.22065 1.1095 3.75048 1.69867 3.45018C2.36413 3.11115 3.12667 3.11115 4.51103 3.11115H11.3444L9.56107 1.32778C9.25727 1.02398 9.25727 0.53165 9.56107 0.22785C9.86487 -0.07595 10.3572 -0.07595 10.661 0.22785L13.772 3.33888C13.8504 3.41728 13.9088 3.50852 13.9466 3.60558C13.9764 3.68188 13.9944 3.76378 13.9988 3.84942C13.9995 3.86248 13.9998 3.87578 13.9998 3.88885C13.9998 3.90122 13.9995 3.91382 13.9988 3.92618C13.9946 4.01438 13.9757 4.09885 13.9447 4.17702C13.9447 4.17748 13.9442 4.17795 13.944 4.17865C13.9067 4.27198 13.8504 4.35972 13.7753 4.43555C13.7753 4.43555 13.7748 4.43602 13.7746 4.43625C13.7744 4.43672 13.7739 4.43695 13.7737 4.43742C13.7732 4.43788 13.7727 4.43835 13.7723 4.43882L10.6612 7.54985C10.3574 7.85365 9.8651 7.85365 9.5613 7.54985C9.2575 7.24605 9.2575 6.75372 9.5613 6.44992L11.3447 4.66655H4.51103C3.36747 4.66655 2.7377 4.66655 2.40497 4.83618C2.11027 4.98622 1.8753 5.22142 1.72503 5.51588C1.5554 5.84862 1.5554 6.47862 1.5554 7.62218V8.55552C1.5554 8.98508 1.20727 9.33322 0.7777 9.33322Z",
    fill: "#444C5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1094_3781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 9.33333,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendToFriendImage);
export default __webpack_public_path__ + "static/media/send-to-friend-image.332b4672acc92c1e48f496ce9c8a2202.svg";
export { ForwardRef as ReactComponent };